import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {FileSelectEvent} from 'primeng/fileupload';
import {environment} from '../../environments/environment';
import {first} from 'rxjs';

@Injectable({providedIn: 'root'})
export class HybridPDFService {

  onUploadSuccess: EventEmitter<IUploadResult> = new EventEmitter<IUploadResult>();
  onUploadError: EventEmitter<IUploadResult> = new EventEmitter<IUploadResult>();

  formId: number = 0;
  selectedPDFFile: File | null = null;
  selectedCSVFile: File | null = null;

  public constructor(private http: HttpClient) {

  }

  public Init(formId: number) {
    this.formId = formId;
    this.selectedPDFFile = null;
    this.selectedCSVFile = null;
  }

  public SelectPDFFile(file: FileSelectEvent) {
    if (file.files && file.files.length > 0) {
      this.selectedPDFFile = file.files[0];
    }
  }

  public SelectCSVFile(file: FileSelectEvent) {
    if (file.files && file.files.length > 0) {
      this.selectedCSVFile = file.files[0];
    }
  }

  public Upload(applySpecificPdf: boolean) {
    console.log("Upload", applySpecificPdf);
    const formData = new FormData();
    formData.append('form_id', this.formId.toString());
    formData.append('apply_specific_pdf', applySpecificPdf ? '1' : '0');
    if (this.selectedPDFFile) {
      formData.append('pdfTemplate', this.selectedPDFFile);
    }
    if (this.selectedCSVFile) {
      formData.append('pdfCoordinates', this.selectedCSVFile);
    }

    this.http.post(environment.api + '/api/forms/fileUpload?token=' + localStorage.getItem('apiToken'),formData)
      .pipe(first())
      .subscribe({
        next:(r:IUploadResult) => {
          if(!Number(r.data.apply_specific_pdf)){
            this.selectedPDFFile = null;
            this.selectedCSVFile = null;
          } else {
            this.selectedPDFFile = null;
            this.selectedCSVFile = null;
          }
          this.onUploadSuccess.emit(r)
        },
        error: (e) => {
          this.onUploadError.emit(e)
        }
      })
  }

}

export interface IUploadResult {
  status: boolean,
  errors: string[],
  data: {
    apply_specific_pdf: string
    coordinates_result: string
    pdf_result: string
    pdf_template_coordinates_file: string
    pdf_template_file: string
  }
}
